import React, {
  FC,
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";

interface FooterContentContextValue {
  content: JSX.Element | null;
  setContent: (content: JSX.Element | null) => void;
}

const FooterContentContext = createContext<FooterContentContextValue>({
  content: null,
  setContent: () => undefined,
});

interface FooterContentProviderProps {
  children: ReactNode;
}

export const FooterContentProvider: FC<FooterContentProviderProps> = ({
  children,
}) => {
  const [content, setContent] = useState<JSX.Element | null>(null);
  return (
    <FooterContentContext.Provider value={{ content, setContent }}>
      {children}
    </FooterContentContext.Provider>
  );
};

export const useFooterContent = (): JSX.Element | null =>
  useContext(FooterContentContext).content;

/** Replaces the footer copy while the calling page is mounted; pass a memoised node. */
export const useFooterOverride = (content: JSX.Element | null): void => {
  const { setContent } = useContext(FooterContentContext);
  useEffect(() => {
    setContent(content);
    return () => setContent(null);
  }, [content, setContent]);
};
